<template>
  <div style="background-color: #f4fbff">
    <Header @onRefreshClick="onRefresh"> </Header>
    <div class="home home-user" >
      <div class="home_notice-search">
        <form method="get">
          <input
            v-model="this.search.name"
            type="search"
            name="searchInput"
            placeholder="ユーザーまたはチームを検索"
          />
          <input
            type="submit"
            onclick="return false;"
            name="submit"
            value="検索"
            @click="searchByName"
          />
        </form>
        <div class="search-btn search-btn_user" @click="showSearch">
          <span>並び替え</span>
        </div>
      </div>
      <van-dialog
        v-model:show="searchModalShow"
        title="並び替え"
        @confirm="searchList"
      >
        <div id="search-modal ">
          <div class="search-modal_inner">
            <div class="search-modal_list">
              <input
                type="radio"
                name="select"
                value="all"
                checked="true"
                id="all"
              />
              <label for="all" class="radio">すべて</label>
              <input type="radio" name="select" value="patient" id="user" />
              <label for="user" class="radio">利用者</label>
              <input type="radio" name="select" value="doctor" id="staff" />
              <label for="staff" class="radio">スタッフ</label>

              <p class="search-modal_title-sub">詳細設定</p>
              <input id="abc" type="checkbox" name="check" />
              <label for="abc" class="checkbox">あいうえお順</label>
            </div>
          </div>
        </div>
      </van-dialog>

      <div
        class="home_past-notice home_user-team" v-for="item in memberList" :key="item.id" v-if="sortOption=='default'">
        <p class="title-days title-team-name" @click="openList(item)" :class="[item.showAll ? '' : 'open']">
          {{ item.team_name }}(オンライン{{ item.onlineCount }}名　オフライン{{item.offlineCount }}名)
        </p>
        <div class="team-block" :style="{ display: item.showAll ? 'block' : 'none' }">
          <div class="user-item" v-for="(member_list, index) in item.member_list.sort((a, b) => {
              if (this.sortOption === 'phonetic') {
                return a.name.localeCompare(b.name, 'ja');
              } else {
                return 0;
              }
            })"
            :key="index" @click="getMemberDetail(member_list)">
            <!-- <p class="user-name" :style="{ opacity: member_list.online_status == 'online' ? '1' : '0.5' }">
              {{ member_list.name }}
              <span class="online" v-if="member_list.online_status == 'online'"></span>
            </p> -->
            <p class="user-name" :style="{ color: member_list.online_status !== 'online' ? '#D9D9D9' : 'inherit' }">
              <span>{{ member_list.name }}</span>
              <span class="online" v-if="member_list.online_status == 'online'"></span>
            </p>
            <span class="user-staff" v-if="member_list.type != 'patient'">スタッフ</span>
            <span class="user-sensor" v-else>
              <div class="user-sensor-item" v-for="(item, index) in member_list.sensor_rows " :key="index">
                <div class="user-sensor-item-title">
                  {{item.name}}
                </div>
                <div class="user-sensor-item-img">
                  <img v-if="item.type== '2'" src="@/assets/img/call/battery_max.svg" />
                  <img v-else-if="item.half_year_flg == 'half_year_ago' || parseFloat(item.battery_level) == 0 " src="@/assets/img/call/battery_undefined.svg" />
                  <img v-else-if="parseFloat(item.battery_level) > 0.25" src="@/assets/img/call/battery_max.svg" />
                  <img v-else src="@/assets/img/call/battery_25.svg" />
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <div
        class="home_past-notice home_user-team" 
        v-for="(group, key) in groupedContacts" 
        :key="key" 
        v-if="sortOption != 'default'"
      >
        <p 
          class="title-days title-user_abc" 
        >
          {{ key }}
        </p>
        <div class="">
          <div 
            class="user-item" 
            v-for="(contact, index) in group" 
            :key="index" 
            @click="getMemberDetail(contact)"
          >
            <p class="user-name" :style="{ color: contact.online_status !== 'online' ? '#D9D9D9' : 'inherit' }">
<!--              <span-->
<!--                class="offline"-->
<!--                v-if="contact.online_status !== 'online'"-->
<!--                >オフライン</span-->
<!--              >-->
              {{ contact.name }}
              <span class="online" v-if="contact.online_status == 'online'"></span>
            </p>
            <span class="user-staff" v-if="contact.type != 'patient'"
              >スタッフ</span>
            <span class="user-sensor" v-else>
              <div class="user-sensor-item" v-for="(item, index2) in contact.sensor_rows " :key="index2">
                <div class="user-sensor-item-title">
                  {{item.name}}
                </div>
                <div class="user-sensor-item-img">
                  <img v-if="item.type== '2'" src="@/assets/img/call/battery_max.svg" />
                  <img v-else-if="item.half_year_flg == 'half_year_ago' || parseFloat(item.battery_level) == 0 " src="@/assets/img/call/battery_undefined.svg" />
                  <img v-else-if="parseFloat(item.battery_level) > 0.25" src="@/assets/img/call/battery_max.svg" />
                  <img v-else src="@/assets/img/call/battery_25.svg" />
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>

      <van-dialog
          v-model:show="refreshModelShow"
          :closeOnClickOverlay="true"
          :showConfirmButton="true"
          :showCancelButton="true"
          @confirm="refreshPatient"
      >
        <div id="tel-popup active">
          <div class="tel-popup_inner">
            <p class="tel-popup_row">
              <span class="tel-popup_name">{{ chooseItem.name }}</span>
            </p>
            <div>
                リフレッシュをします。よろしいですか？
            </div>
          </div>
        </div>
      </van-dialog>

      <van-dialog
        v-model:show="callModalShow"
        :closeOnClickOverlay="true"
        :showConfirmButton="false"
        :showCancelButton="false"
      >
        <div id="tel-popup active">
          <div class="tel-popup_inner">
            <p class="tel-popup_row">
              <span class="tel-popup_name">{{ chooseItem.name }}</span>
            </p>
            <div class="tel-popup_row tel-popup_btn-area">
              <div class="tel-popup_btn-area-div">
                <div class="tel-popup_btn voice" @click="call('audio')">
                  音声通話
                </div>
                <div class="tel-popup_btn video" @click="call('video')">
                  ビデオ通話
                </div>
                <div class="tel-popup_btn chat" @click="toChat">
                  チャット
                </div>
              </div>
              <div class="tel-popup_btn-area-div tel-popup_btn-area-div-bottom" v-show="chooseItem.type == 'patient'" @click="showRefreshModel()">
                リフレッシュ
              </div>
            </div>
            <!-- <div class="tel-popup_row tel-popup_btn-area" v-if="this.chooseItem.type=='patient'">
              <div @click="goToPage('binahData')">
                <img src="@/assets/img/home/icon_log.png" alt="" style="width:30px; height: 30px;">ビナーデータ</div>
            </div> -->
          </div>
        </div>
      </van-dialog>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import Header from "@/components/Header.vue";
import {Toast} from "vant";
import "vant/es/toast/style";
import { FindTeamMembers } from "@/services/team";
import { RefreshUserInfo } from "@/services/login";
import {refreshApp} from "@/services/user";

export default {
  data() {
    return {
      memberList: [],
      doctorList: [],
      refreshing: false,
      searchModalShow: false,
      callModalShow: false,
      userInfo: null,
      chooseItem: {
        id: "",
        name: "",
        type: "",
      },
      search: {
        type: "all",
        name: "",
      },
      sortOption: "default",
      memberListInterval:null,
      refreshModelShow: false,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    this.userInfo = JSON.parse(
      localStorage.getItem(process.env.VUE_APP_USER_KEY)
    );

    if(this.memberListInterval){
      clearInterval(this.memberListInterval); //销毁之前定时器
    }
    this.initMemberList();
    this.memberListInterval = setInterval(() => {
      //每秒更新一次时间
      this.initMemberList();
    }, 5000);
  },
  beforeUnmount(){
    if(this.memberListInterval){
      clearInterval(this.memberListInterval);
    }
  },
  methods: {
    showRefreshModel() {
      this.refreshModelShow = true;
    },
    async refreshPatient() {
      const res = await refreshApp({account_ids:[this.chooseItem.id]});
      if(res.data.code >= 0){
        Toast.success("リフレッシュ成功");
      }else{
        Toast.fail("リフレッシュ失敗");
      }
    },
    searchByName() {
      this.initMemberList();
    },
    searchList() {
      sessionStorage.removeItem("tsunagaru_patient_list_close")
      this.search.type = JQuery("input[type='radio']:checked").val();
      if (document.getElementById("abc").checked) {
        this.sortOption = "phonetic";
      } else {
        this.sortOption = "default";
      }
      this.$nextTick(() => {
        this.initMemberList();
      });
    },
    onRefresh() {
      Toast.loading({
        message: "",
        forbidClick: true,
        duration: 1000,
      });
      this.initMemberList();
    },
    async initMemberList() {
      let res = await FindTeamMembers({ search: this.search })
      this.memberList = res.data.data;
      this.refreshing = false;
      if (this.memberList && this.memberList.length > 0) {
        this.memberList.forEach((item) => {
          let close_list_str = sessionStorage.getItem("tsunagaru_patient_list_close") || "";
          let close_list = close_list_str ? close_list_str.split(',') : [];
          if (close_list.includes(item.team_id)) {
            item.showAll = false;
          }else{
            item.showAll = true;
          }
          const onlineMembers = item.member_list.filter(function (member) {
            return member.online_status == "online";
          });
          item.onlineCount = onlineMembers.length;
          item.offlineCount = item.member_list.length - onlineMembers.length;
        });
      }
      if(this.sortOption != 'default'){
        this.groupMemberList();
      }
      this.$forceUpdate();
    },
    groupMemberList(){
      if (this.memberList && this.memberList.length > 0) {
          // 合并所有联系人
          const allContacts = [];
          this.memberList.forEach((team) => {
            team.member_list.forEach((contact) => {
              // 取出id、name和kana属性
              const { id, name, kana, type, online_status ,sensor_rows} = contact;
              // 将联系人加入allContacts数组
              allContacts.push({ id, name, kana, type, online_status ,sensor_rows});
            });
          });

          // 去重
          const uniqueContacts = [];
          allContacts.forEach((contact) => {
            const isDuplicate = uniqueContacts.some((c) => c.id === contact.id);
            if (!isDuplicate) {
              uniqueContacts.push(contact);
            }
          });

          // 按照kana分组
          const alphabet = [
            "あ", "い", "う", "え", "お",
            "か", "き", "く", "け", "こ",
            "さ", "し", "す", "せ", "そ",
            "た", "ち", "つ", "て", "と",
            "な", "に", "ぬ", "ね", "の",
            "は", "ひ", "ふ", "へ", "ほ",
            "ま", "み", "む", "め", "も",
            "や", "ゆ", "よ",
            "ら", "り", "る", "れ", "ろ",
            "わ", "を", "ん"
          ];
          const groupedContacts = {};
          // 添加“其他”或“＃”分组
          groupedContacts["#"] = [];

          uniqueContacts.forEach((contact) => {
            const { id, name, kana, type, online_status ,sensor_rows} = contact;

             // 如果kana为空或不在五十音表中，将联系人放入“其他”分组
              if (!kana || !alphabet.includes(kana.charAt(0))) {
                groupedContacts["#"].push({ id, name, kana, type, online_status ,sensor_rows });
                return;
              }

              // 找到该联系人的假名的首个字符，并将其加入对应的分组
              const firstChar = kana.charAt(0);
              if (!groupedContacts[firstChar]) {
                groupedContacts[firstChar] = [];
              }
              groupedContacts[firstChar].push({ id, name, kana, type, online_status ,sensor_rows});
            });

          // 更新分组后的联系人列表
          this.groupedContacts = groupedContacts;
          console.log(this.groupedContacts)
        }
    },
    getMemberDetail(item) {
      this.chooseItem = item;
      this.callModalShow = true;
    },
    onClickLeft() {
      history.back();
    },
    openList(item) {
      item.showAll = !item.showAll;
      let close_list_str = sessionStorage.getItem("tsunagaru_patient_list_close") || "";
      let close_list = close_list_str ? close_list_str.split(',') : [];
      if(item.showAll){
        close_list = close_list.filter(close_item => close_item !== item.team_id);
      }else{
        if (!close_list.includes(item.team_id)) {
          close_list.push(item.team_id);
        }
      }
      sessionStorage.setItem("tsunagaru_patient_list_close",close_list.join(','));
    },
    showSearch() {
      this.searchModalShow = true;
    },
    call(type) {
      if(type != 'audio') {
        this.$router.push({
          path: "/beforeCall",
          query: {type:this.chooseItem.type,chooseItem_id:this.chooseItem.id},
        });
        return
      }
      this.callModalShow = false;
      this.$emit('callUser',type,this.chooseItem);
    },
    toChat() {
      if (this.chooseItem && this.chooseItem.type == "doctor") {
        this.$router.push({
          path: "/chatDetail",
          query: {
            doctor_id: this.chooseItem.id,
            doctor_name: this.chooseItem.name,
          },
        });
      } else {
        RefreshUserInfo().then((res) => {
          if (res.data.data.user.auth_list.includes("notice")) {
            this.$router.push({
              path: "/chatToPatient",
              query: {
                patient_id: this.chooseItem.id,
                patient_name: this.chooseItem.name,
              },
            });
          } else {
            Toast.fail("権限がありません");
          }
        });
      }
    },

    goToPage(pageName, params = {}) {
      const routes = {
        binahData:()=>{
          return {path: "/binahData", query: { patient_id:  this.chooseItem.id, patient_name: this.chooseItem.name, } }
        },
      };
      const route = routes[pageName];
      if (typeof route === "function") {
        this.$router.push(route());
      } else {
        this.$router.push(route);
      }
    },
  },
  computed: {},
};
</script>

<style scoped>
   
   
  
   
</style>
